var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "url(#paint0_linear_1553_3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4727 11C31.3164 11 32 11.6836 32 12.5266C32 12.9063 31.8594 13.2723 31.6016 13.5531L25.75 19.9922V26.3555C25.75 26.8633 25.3633 27.25 24.8555 27.25C24.707 27.25 24.5312 27.1914 24.3828 27.0859L21.2656 24.8164C20.9414 24.582 20.75 24.207 20.75 23.8086V19.9922L14.8984 13.5531C14.6406 13.2723 14.5 12.9063 14.5 12.5266C14.5 11.6836 15.1836 11 16.0273 11H30.4727ZM15.8203 12.7125L21.8359 19.3281C21.9414 19.4453 22 19.5938 22 19.75V23.8086L24.5 25.625V19.75C24.5 19.5938 24.5586 19.4453 24.6641 19.3281L30.6797 12.7125C30.7227 12.6617 30.75 12.5953 30.75 12.5266C30.75 12.3738 30.625 12.25 30.4727 12.25H16.0273C15.875 12.25 15.75 12.3738 15.75 12.5266C15.75 12.5953 15.7773 12.6617 15.8203 12.7125ZM8.32188 15.2109L14.3359 21.8281C14.4414 21.9453 14.5 22.0938 14.5 22.25V25.0586L17 26.875V22.25C17 22.0938 17.0586 21.9453 17.1641 21.8281L18.3008 20.5781C18.5312 20.3242 18.9258 20.3047 19.1836 20.5391C19.4375 20.7695 19.457 21.1641 19.2227 21.4219L18.25 22.4922V27.6055C18.25 28.1133 17.8633 28.5 17.3555 28.5C17.207 28.5 17.0312 28.4414 16.8828 28.3359L13.7656 26.0664C13.4414 25.832 13.25 25.457 13.25 25.0586V22.4922L7.39687 16.0547C7.14152 15.7734 7 15.4063 7 15.0273C7 14.1836 7.68359 13.5 8.52656 13.5H13.25C13.5938 13.5 13.875 13.7812 13.875 14.125C13.875 14.4688 13.5938 14.75 13.25 14.75H8.52656C8.37383 14.75 8.25 14.875 8.25 15.0273C8.25 15.0938 8.27578 15.1602 8.32188 15.2109Z",
    fill: "#363636"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1553_3",
    x1: 3.02494e-7,
    y1: 19,
    x2: 40,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3192B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#4DBA78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#7EB76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#C8A734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E45959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterButton);
export default __webpack_public_path__ + "static/media/filter_button.9906443372d2a8bb4a554d0d751de6f9.svg";
export { ForwardRef as ReactComponent };